import { UUID } from '../shared/UUID';
import {
  convertIAddressResponseToIPropertyAddressData,
  convertIPropertyAddressDataToIAddressResponse,
  IAddressResponse,
} from './Address/IAddress';
import { IPropertyAddressData } from '../address/IPropertyAddressData';
import { undefConversion } from '../../utilities/shared/undefinedConversion';
import { IPartySignatory } from '../../ui-toolkit/orders/interfaces/IPartySignatory';
import { IPropertyAddress } from '../../ui-toolkit/orders/interfaces/IPropertyAddress';

export interface ISignatoryResponse {
  id?: UUID;
  entity_id?: UUID;
  first_name: string;
  middle_name?: string;
  last_name: string;
  email?: string;
  phone_number?: string;
  party_sequence?: number;
  address?: IAddressResponse;
}

export interface ISignatoryData {
  id?: string;
  entityName?: UUID;
  firstName: string;
  middleName?: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  partySequence?: number;
  address?: IPropertyAddressData;
}

export const convertISignatoryResponseToISignatoryData = ({
  first_name,
  middle_name,
  last_name,
  phone_number,
  party_sequence,
  address,
  id,
}: ISignatoryResponse): ISignatoryData => ({
  firstName: first_name,
  middleName: middle_name,
  lastName: last_name,
  partySequence: party_sequence,
  phoneNumber: phone_number,
  address: undefConversion(convertIAddressResponseToIPropertyAddressData, address),
  id,
});

export const convertISignatoryDataToISignatoryResponse = ({
  id,
  entityName,
  firstName,
  middleName,
  lastName,
  email,
  address,
  phoneNumber,
  partySequence,
}: ISignatoryData): ISignatoryResponse => ({
  id,
  email,
  entity_id: entityName,
  first_name: firstName,
  middle_name: middleName,
  last_name: lastName,
  phone_number: phoneNumber,
  party_sequence: partySequence,
  address: undefConversion(convertIPropertyAddressDataToIAddressResponse, address),
});

export const convertISignatoryDataToIPartySignatory = ({
  address,
  firstName,
  middleName,
  lastName,
  phoneNumber,
  partySequence,
  ...rest
}: ISignatoryData): IPartySignatory => ({
  address: undefConversion(convertIPropertyAddressDataToIPropertyAddress, address),
  firstName: firstName,
  middleName: middleName,
  lastName: lastName,
  partySequence: partySequence,
  phoneNumber: phoneNumber,
  ...rest,
});

export const convertIPropertyAddressDataToIPropertyAddress = ({
  streetAddress,
  unit,
  city,
  stateAbbreviation,
  zipCode,
}: IPropertyAddressData): IPropertyAddress => ({
  street_address: streetAddress,
  unit: unit || null,
  city: city,
  state: stateAbbreviation,
  zip_code: zipCode,
  countyState: '',
  countyName: '',
  countyFips: '',
});
